import React, { useState } from 'react';
import { connect } from 'react-redux';
import { toggleLoading } from '../../Redux/Actions/Loading';
import axios from 'axios';
import { toast } from 'react-toastify';
import moment from 'moment';
import DatePicker from 'material-ui/DatePicker';
import areIntlLocalesSupported from 'intl-locales-supported';
let DateTimeFormat;

/**
 * Use the native Intl.DateTimeFormat if available, or a polyfill if not.
 */
if (areIntlLocalesSupported(['fr', 'fa-IR'])) {
  DateTimeFormat = global.Intl.DateTimeFormat;
} else {
  const IntlPolyfill = require('intl');
  DateTimeFormat = IntlPolyfill.DateTimeFormat;
  require('intl/locale-data/jsonp/fr');
  require('intl/locale-data/jsonp/fa-IR');
}

const EmailSender = ({ onToggleLoading }) => {
  const [msg, setMsg] = useState('Veuillez sélectionner une date');
  const [emails, setEmails] = useState([]);
  const [list, setList] = useState([]);
  const [content, setContent] = useState('');

  const formatDate = date => {
    return moment(date).format('YYYY-MM-DD');
  };

  const handleDateChange = (e, date) => {
    const formatedDate = moment(date).format('YYYY-MM-DD');
    axios
      .get(`/api/v1/configs/emails/${formatedDate}`)
      .then(resp => resp.data)
      .then(data => {
        setEmails(data.emails);
        setList(data.emails.map(e => e.email));
        setMsg("Il n'y a aucun courriel à cette date");
      })
      .catch(e => {
        toast.error(`Impossible d'obtenir les courriels`);
      });
  };

  const handleInputChange = event => {
    const target = event.target;
    if (target.checked) {
      setList(list.concat(target.name));
    } else {
      setList(list.filter(i => i !== target.name));
    }
  };

  const send = () => {
    if (list.length) {
      onToggleLoading();
      const object = {
        emails: list,
        content,
      };
      axios
        .post(`/api/v1/configs/emails`, { object })
        .then(resp => {
          onToggleLoading();
          setList([]);
          setContent('');
        })
        .catch(e => {
          onToggleLoading();
          toast.error(`Impossible d'envoyer les courriels`);
        });
    }
  };

  return (
    <div className="content-box">
      <h3 className="content-box-header bg-default">Courriel</h3>
      <div className="content-box-wrapper">
        <div className="row">
          <div className="col-md-12">
            <DatePicker
              hintText="Date"
              autoOk
              formatDate={formatDate}
              locale="fr"
              DateTimeFormat={DateTimeFormat}
              okLabel="OK"
              cancelLabel="Annuler"
              onChange={handleDateChange}
              firstDayOfWeek={0}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-md-12">
            <div className="emails-list">
              {!emails.length ? (
                <i>{msg}</i>
              ) : (
                emails.map(e => {
                  return (
                    <p key={e.email}>
                      <input
                        type="checkbox"
                        name={e.email}
                        id={e.email}
                        checked={list.includes(e.email)}
                        onChange={handleInputChange}
                      />
                      <label htmlFor={e.email}>
                        {e.email.toLowerCase()} -{' '}
                        <i>{e.client.toUpperCase()}</i>
                      </label>
                    </p>
                  );
                })
              )}
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-12">
            Contenu de message
            <div className="email-body">
              <textarea
                className="form-control email-content"
                cols="30"
                rows="10"
                value={content}
                onChange={e => setContent(e.target.value)}
              />
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-md-12">
            <button
              className="btn btn-primary"
              id="send-email-btn"
              onClick={send}
            >
              Envoyer
            </button>
          </div>
        </div>
        <div className="email-success" />
      </div>
    </div>
  );
};

const mapDispatchToProps = dispatch => ({
  onToggleLoading: () => dispatch(toggleLoading()),
});

export default connect(
  null,
  mapDispatchToProps,
)(EmailSender);
